  <div class="row p-2 g-2 mt-2">
    <div class="col-lg-12 card-layout pt-4 mt-5 mb-3 ms-2 me-2">
      <div class="card-text">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
